import { isPocOwnedPath } from './pocOwnedPaths';

// POC (SH-275, spec 10.01.04): rewrite an internal off-page href to the live
// site when the flag is on; otherwise return it unchanged. Routes this project
// already owns are exempt — see `lib/pocOwnedPaths.ts`.
const getLiveSiteUrl = () =>
  process.env.NEXT_PUBLIC_POC_REDIRECTION_TO_LIVE_SITE_ENABLED === 'true'
    ? process.env.NEXT_PUBLIC_POC_LIVE_SITE_URL?.replace(/\/+$/, '')
    : undefined;

export const toLiveHref = (href: string): string => {
  const liveSiteUrl = getLiveSiteUrl();
  return liveSiteUrl &&
    href.startsWith('/') &&
    !href.startsWith('//') &&
    !isPocOwnedPath(href)
    ? `${liveSiteUrl}${href}`
    : href;
};
